import FondoDashboard from "../../images/bg-dashboard.jpg";
import DashboardSuperAdminComponent from "./components/libs/superadmin";
import DashboardAdminComponent from "./components/libs/admin";
import DashboardOperatorComponent from "./components/libs/operator";
import DashboardGenericComponent from "./components/libs/generic";
import { useLocation } from "react-router-dom";
import React from "react";
import { usersGetbyToken } from "../../../libs/apis";
import { useRouterStore } from "../../../libs/stores";
import { message } from "antd";
import { DashboardTypeEnum } from "../../../libs/enums";
import {
  getValidRoutes,
  extractModuleBase,
  findClosestModuleByPath,
  normalizePath,
  returnDecrypt,
} from "../../../libs/helpers";

const Dashboard = () => {
  const location = useLocation();
  const typeDashboardCodeEncrypt = useRouterStore(
    (state) => state.typeDashboardCode,
  );
  const typeDashboardCode = returnDecrypt(typeDashboardCodeEncrypt!);
  const validateModulesFromApi = useRouterStore(
    (state) => state.validateModulesFromApi,
  );
  const setOptions = useRouterStore((state) => state.setOptions);
  const modules = useRouterStore((state) => state.modules);
  const previousModuleBase = useRouterStore(
    (state) => state.previousModuleBase,
  );
  const setPreviousModuleBase = useRouterStore(
    (state) => state.setPreviousModuleBase,
  );

  const validRoutesMap = React.useMemo(() => getValidRoutes(), []);
  const [hasValidatedInitially, setHasValidatedInitially] =
    React.useState(false);

  const handleValidate = React.useCallback(async () => {
    try {
      await usersGetbyToken();
    } catch (err: any) {
      message.error(err.toString());
    }
  }, []);

  React.useEffect(() => {
    if (!hasValidatedInitially) {
      const initializeApp = async () => {
        await handleValidate();
        if (modules.length === 0) await validateModulesFromApi();
        setHasValidatedInitially(true);
      };
      initializeApp();
    }
  }, [
    hasValidatedInitially,
    handleValidate,
    validateModulesFromApi,
    modules.length,
  ]);

  React.useEffect(() => {
    if (!hasValidatedInitially || modules.length === 0) return;

    const currentPath = location.pathname;
    const moduleBase = extractModuleBase(currentPath);

    if (previousModuleBase !== moduleBase) setPreviousModuleBase(moduleBase);

    const timer = setTimeout(() => {
      const closestModule = findClosestModuleByPath(
        modules,
        normalizePath(currentPath),
      );
      if (closestModule?.options?.length) {
        const validRoutes = validRoutesMap[closestModule.to] || new Set();
        const validOptions = closestModule.options.filter((option) =>
          validRoutes.size > 0 ? validRoutes.has(option.to) : true,
        );
        setOptions(validOptions);
      } else {
        setOptions([]);
      }
    }, 50);

    return () => clearTimeout(timer);
  }, [
    location.pathname,
    modules,
    hasValidatedInitially,
    validRoutesMap,
    setOptions,
    setPreviousModuleBase,
    previousModuleBase,
  ]);

  const renderDashboard = () => {
    switch (typeDashboardCode) {
      case DashboardTypeEnum.SUPERADMIN:
        return <DashboardSuperAdminComponent />;
      case DashboardTypeEnum.CLIENT:
        return <DashboardAdminComponent />;
      case DashboardTypeEnum.OPERATOR:
        return <DashboardOperatorComponent />;
      default:
        return <DashboardGenericComponent />;
    }
  };

  return (
    <div
      style={{
        position: "relative",
        height: "100%",
        width: "100%",
        maxWidth: "100%",
        overflowX: "hidden",
        overflowY: "hidden",
        backgroundImage: `url(${FondoDashboard})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        backgroundAttachment: "fixed",
        backgroundSize: "cover",
      }}
    >
      {renderDashboard()}
    </div>
  );
};

export default Dashboard;
